export default "__VITE_ASSET__DeWMfFFa__"